"use client";
import * as React from "react";
const SvgSpinnerSharp = ({
  title,
  titleId,
  ...props
}) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "0 0 16 16", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { fill: "currentColor", fillRule: "evenodd", d: "M8.53 2a6 6 0 1 0 0 12v2a8 8 0 1 1 6.93-12l-1.73 1a6 6 0 0 0-5.2-3", clipRule: "evenodd" }));
export {
  SvgSpinnerSharp as default
};
